module.exports = __webpack_public_path__ + "static/img/icon-close.33582da7.svg";